import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface FooterLinkProps {
	label: string
	className?: string
	href?: string
}

export function FooterLink({ label, className, href = '#' }: FooterLinkProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		// Check if the href is an anchor link
		if (href.startsWith('#')) {
			e.preventDefault()
			const targetId = href.substring(1)
			const targetElement = document.getElementById(targetId)

			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' })
			}
		} else if (!href.startsWith('http') && !href.startsWith('mailto:')) {
			// For internal links (not external URLs or mailto links), scroll to top after navigation
			setTimeout(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			}, 100)
		}
	}

	return (
		<Link
			to={href}
			onClick={handleClick}
			className={cn(
				'text-sm text-muted-foreground hover:text-foreground',
				className,
			)}>
			{label}
		</Link>
	)
}
